import Toilets from './Toilets';
import { connect } from 'react-redux';
import {
  getChallengeCategory,
  completeChallenge,
  getOffers,
} from '../../actions/challenges';
import { AppState } from '../../interfaces';
import { generalData } from '../../actions/general';

const mapStateToProps = (state: AppState) => ({
  challenges: state.challengesReducer,
  listLocation: state.listLocationReducer,
  completeTask: state.completeChallengesReducer,
});

const mapDispatchToProps = (dispatch) => ({
  getChallengeCategory: (id, cat) => dispatch(getChallengeCategory(id, cat)),
  completeChallenge: (id, challengeId) =>
    dispatch(completeChallenge(id, challengeId)),
  generalData: () => dispatch(generalData()),
  getOffers: (id) => dispatch(getOffers(id)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Toilets);
